import {
  Box,
  Button,
  HStack,
  VStack,
  Text,
  Select,
  Input,
  Link,
  Checkbox,
  Collapse,
  Icon,
  Slider,
  SliderTrack,
  SliderFilledTrack,
  SliderThumb
} from "@chakra-ui/react";
import { observer } from "mobx-react-lite";
import React, { useState, useMemo, useEffect, useRef } from "react";
import { useStores } from "../../store/store_context";
import { authFetch } from "../../auth/auth";
import { ru } from "date-fns/locale";
import { FiChevronDown, FiChevronUp } from "react-icons/fi";
import baseUrl from "../../vars";


const SelfFilters = observer(() => {
  const { pageStore } = useStores();

  const [columnsState, setColumnsState] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const getActiveColumns = async (report = "mops") => {
    try {
      const response = await authFetch(
        `${baseUrl}/api/active_columns?report=${report}`,
        {
          method: "GET",
          headers: {
            "Accept": "application/json",
            "Authorization": `Bearer ${pageStore.token}`,
          },
        }
      );

      const result = await response.json();
      if (!result) return;

      const activeKeys = Array.isArray(result) ? result : result.active || [];

      const newColumns = pageStore.columnConfigMops.map(col => ({
        ...col,
        active: activeKeys.map(String).includes(String(col.key)),
      }));

      // обновляем локальный state и стору
      setColumnsState(newColumns);
      pageStore.setColumnConfigMops(newColumns);
    } catch (err) {
      console.error("Error fetching active columns:", err);
    }
  };

  useEffect(() => {
    setColumnsState(pageStore.columnConfigMops.map(col => ({ ...col })));
    getActiveColumns("mops");
  }, []);

  const toggleColumn = (index) => {
    const newColumns = [...columnsState];
    newColumns[index].active = !newColumns[index].active;
    setColumnsState(newColumns);

    // синхронизация с исходным columnConfig
    pageStore.columnConfigMops[index].active = newColumns[index].active;
    pageStore.setColumnConfigMops(newColumns)
  };

  const updateStore = (newColumns) => {
    setColumnsState(newColumns);
    pageStore.setColumnConfigMops(newColumns);
  };

  // Выбрать все / снять все
  const selectAllColumns = () => {
    const allActive = columnsState.every(c => c.active);
    const newColumns = columnsState.map(c => ({ ...c, active: !allActive }));
    updateStore(newColumns);
  };

  const toggleDropdown = () => setIsOpen(prev => !prev);

  // закрытие при клике вне
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);


  return (
    <HStack
      justify="space-between"
      mb={4}
      borderBottom="1px solid #444"
      pb={3}
      w="full"
    >
      <Button
        size="sm"
        bg="#333"
        color="white"
        onClick={() => pageStore.setOpenFilters(!pageStore.open_filter)}
        _hover={{ bg: "#444" }}
        leftIcon={pageStore.open_filter ? <span>−</span> : <span>+</span>}
      >
        {pageStore.open_filter ? "Скрыть фильтры" : "Открыть фильтры"}
      </Button>
      <HStack spacing={4} flex="1">
        <Text fontSize="12px" fontWeight="bold" color="gray.400" whiteSpace="nowrap">
          Высота строк: {pageStore.rowHeight}
        </Text>

        <HStack spacing={2} flex="1" maxW="300px">
          <Button
            size="xs"
            onClick={() => pageStore.setRowHeight(Math.max(0, pageStore.rowHeight - 1))}
          >
            -
          </Button>

          <Slider
            id="row-padding-slider"
            min={0}
            max={10}
            step={1}
            value={pageStore.rowHeight}
            onChange={(v) => pageStore.setRowHeight(v)}
            colorScheme="green"
          >
            <SliderTrack bg="#444">
              <SliderFilledTrack />
            </SliderTrack>
            <SliderThumb boxSize={3} />
          </Slider>

          <Button
            size="xs"
            onClick={() => pageStore.setRowHeight(Math.min(10, pageStore.rowHeight + 1))}
          >
            +
          </Button>
        </HStack>
        <Text
          fontSize="12px"
          color="gray.400"
          fontWeight="600"
          whiteSpace="nowrap"
        >
          Время запроса: {pageStore.request_time.toFixed(2)} сек.
        </Text>
      </HStack>
    </HStack>
  )
})

export default SelfFilters
